import React, {PureComponent} from 'react'
import SearchFormDates from "./SearchFormDates"

export default class AdminTableInput extends PureComponent {
  state = {
    from: null,
    to: null
  }

  onFilter = (filter) => {
    const dateString = (filter.from ? filter.from.format('YYYY-MM-DD') : '') + ' - ' + (filter.to ? filter.to.format('YYYY-MM-DD') : '')
    const event = {target: {name: 'filterValue', value: dateString}}
    this.props.onChange(event)
    this.setState({from: filter.from, to: filter.to})
  }

  render() {
    const {
      type,
      name,
      value,
      onChange
    } = this.props


    return (<>
          {type === 'text' &&
          <input type={type}
                 name={name}
                 value={value}
                 className="form-control"
                 onChange={onChange}
          />}
          {type == 'date' &&
          <SearchFormDates onFilter={this.onFilter} from={this.state.from} to={this.state.to}
          />}
        </>
    )
  }
}
